/*
 * Kivora Home — product-page sections (kv-pdp-*). Buttons rendered by snippets/kv-pdp-buy.liquid.
 * [data-kv-buy="scroll"]  smooth-scroll to the buy box and focus Add to cart.
 * [data-kv-buy="add"]     add the variant picked in the buy box to the cart, then stay / cart / checkout.
 */
(function () {
  if (window.__kvPdpInit) return;
  window.__kvPdpInit = true;

  function root() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function productForm() {
    // Skip Dawn's hidden Shop Pay installments form, which also posts to /cart/add.
    return (
      document.querySelector('product-info product-form form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"][id^="product-form"]:not([id*="installment"])')
    );
  }

  function scrollToBuyBox(btn) {
    var form = productForm();
    var target = (form && (form.closest('.product__info-container') || form)) || document.getElementById('MainContent');
    if (!target) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = target.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: Math.max(top, 0), behavior: reduce ? 'auto' : 'smooth' });
    var atc = form && form.querySelector('[type="submit"]');
    if (atc) {
      setTimeout(function () {
        atc.focus({ preventScroll: true });
      }, reduce ? 0 : 450);
    }
  }

  function addToCart(btn) {
    var id = btn.getAttribute('data-variant');
    var form = productForm();
    var picked = form && form.querySelector('[name="id"]');
    if (picked && picked.value) id = picked.value;
    if (!id || btn.getAttribute('aria-busy') === 'true') return;

    var label = btn.innerHTML;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Adding…';

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) throw r;
        return r.json();
      })
      .then(function () {
        var after = btn.getAttribute('data-after');
        if (after === 'checkout') {
          window.location.href = root() + 'checkout';
          return;
        }
        if (after === 'cart') {
          window.location.href = root() + 'cart';
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        btn.textContent = 'Added ✓';
        setTimeout(function () {
          btn.innerHTML = label;
          btn.removeAttribute('aria-busy');
        }, 1600);
      })
      .catch(function () {
        btn.innerHTML = label;
        btn.removeAttribute('aria-busy');
        alert('Sorry, this item could not be added to the cart.');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kv-buy]');
    if (!btn) return;
    var action = btn.getAttribute('data-kv-buy');
    if (action === 'scroll') {
      if (!productForm()) return;
      e.preventDefault();
      scrollToBuyBox(btn);
    } else if (action === 'add') {
      e.preventDefault();
      addToCart(btn);
    }
  });
})();

/*
 * MSS product page (main-product) — 1) the cart-aware offer box counter, 2) "smart" Anime × Character dropdowns,
 * 3) the mobile sticky Add to cart bar (<mss-sticky-atc>).
 *
 * 1) [data-mss-offer] (snippets/kv-offer-box.liquid) is server-rendered from the cart, then refreshed on pageshow
 *    (back/forward cache) and after every cart update (Dawn pub/sub cartUpdate, 'cart:refresh', 'mss:cart-updated').
 *    It counts exactly like the pick tray and the drawer: n = mss-cart-state `eligible + giftcard_units` (gift cards
 *    from the B2G1 collection count as "buy" items, never as the free one); "applied" = Shopify's own free units.
 *    One cart update = at most ONE request: every trigger is debounced into one refresh; when the pick tray is active
 *    it already re-fetches sections/mss-cart-state and broadcasts it ('mss:cart-state'), so the box reuses that and
 *    only fetches itself (just /?sections=mss-cart-state) if no state arrives in time. /cart.js + the printed
 *    product ids ([data-mss-offer-ids]) are a last-resort fallback when the state section is unavailable.
 * 2) variant-selects[data-mss-smart] (snippets/product-variant-picker.liquid): when an earlier dropdown changes and the
 *    current combination is not in stock, the later dropdowns are moved to the first in-stock combination BEFORE
 *    Dawn's own change handler reads the selection (capture phase), so Dawn fetches a real, available variant.
 * 3) <mss-sticky-atc> (sections/main-product.liquid, phones < 750px only): slides up while the main Add to cart is out
 *    of view; its button submits the SAME product form (Dawn's product-form handles the add, drawer and errors), or
 *    scrolls to the variant picker when the current choice can't be bought. Hidden while the pick tray shows or a
 *    drawer/modal is open. Thumbnail + price follow the selected variant (Dawn's variantChange section HTML).
 */
(function () {
  if (window.__mssPdpInit) return;
  window.__mssPdpInit = true;

  function root() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ---------- 1. Offer box counter ---------- */
  function offerBoxes() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-mss-offer]'));
  }

  function readJson(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function fill(tpl, n, k, f) {
    return String(tpl || '')
      .split('[n]')
      .join(String(n))
      .split('[k]')
      .join(String(k))
      .split('[f]')
      .join(String(f == null ? '' : f));
  }

  // Shared offer rule (layout/theme.liquid). Without it everything degrades to Buy 2 Get 1.
  var FALLBACK_OFFER = {
    live: function () {
      return false;
    },
    next: function (q) {
      return { need: 3 - (q % 3), at: q + 3 - (q % 3), free: Math.floor(q / 3) + 1 };
    },
    complete: function (q) {
      return q > 0 && q % 3 === 0;
    },
    serverSays: function () {},
  };
  function offer() {
    return window.MssOffer || FALLBACK_OFFER;
  }

  function setLine(el, text) {
    if (!el) return;
    var span = el.querySelector('[data-mss-offer-text]');
    if (span && span.textContent !== text) span.textContent = text;
    if (text) el.removeAttribute('hidden');
    else el.setAttribute('hidden', '');
  }

  // n = units that count toward the 3 (boxes + B2G1 gift cards); free = units Shopify made free.
  // Two rows can carry a counter: the Halloween ladder (mode "hw", Buy 3 Get 2 maths, hidden at the end) and the
  // permanent Buy 2 Get 1 row (mode "b2g1", always n % 3 maths — it is the row that shows after the end).
  function renderOffer(n, free) {
    var O = offer();
    offerBoxes().forEach(function (box) {
      var cfg = readJson(box.querySelector('[data-mss-offer-cfg]')) || {};
      var cartText = '';
      if (cfg.mode === 'hw') {
        var nx = O.next(n, true);
        if (n > 0 && (!O.complete(n, true) || n < 5)) {
          cartText = fill(nx.free === 1 ? cfg.cartOne : cfg.cartMany, n, nx.need, nx.free);
        }
        var cur = n >= 5 ? 5 : n >= 3 ? 3 : 0;
        box.querySelectorAll('[data-tier]').forEach(function (li) {
          li.classList.toggle('is-current', Number(li.getAttribute('data-tier')) === cur);
        });
      } else {
        var bx = O.next(n, false);
        cartText = n > 0 && !O.complete(n, false) ? fill(cfg.cart, n, bx.need) : '';
      }
      var appliedText = '';
      if (free === 1) appliedText = fill(cfg.appliedOne, n, free);
      else if (free > 1) appliedText = fill(cfg.applied, n, free);
      setLine(box.querySelector('[data-mss-offer-line]'), cartText);
      setLine(box.querySelector('[data-mss-offer-applied]'), appliedText);
      box.setAttribute('data-mss-offer-count', String(n));
      box.setAttribute('data-mss-offer-free', String(free));
    });
  }

  function validState(state) {
    return Boolean(state && typeof state.eligible === 'number' && typeof state.items === 'number');
  }

  function renderState(state) {
    // The server's gate (mss-cart-state is never cached) wins over a slow device clock.
    if (state.b3g2_live === false && offer().live()) offer().serverSays(false);
    var n = Math.max(0, Number(state.eligible) || 0) + Math.max(0, Number(state.giftcard_units) || 0);
    renderOffer(n, Math.max(0, Number(state.free_units) || 0));
  }

  function parseStateHtml(html) {
    if (!html) return null;
    var holder = document.createElement('div');
    holder.innerHTML = html;
    return readJson(holder.querySelector('#mss-cart-state'));
  }

  function fetchState() {
    return fetch(root() + '?sections=mss-cart-state', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (json) {
        return json ? parseStateHtml(json['mss-cart-state']) : null;
      })
      .catch(function () {
        return null;
      });
  }

  function fetchCart() {
    return fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  // Last resort only (state section missing): count the cart lines whose product is in the printed id list.
  function fromCart(cart) {
    var ids = {};
    offerBoxes().forEach(function (box) {
      (readJson(box.querySelector('[data-mss-offer-ids]')) || []).forEach(function (id) {
        ids[String(id)] = true;
      });
    });
    var n = 0;
    var free = 0;
    (cart.items || []).forEach(function (line) {
      if (ids[String(line.product_id)]) n += line.quantity;
      if (!(line.original_price > 0)) return;
      (line.line_level_discount_allocations || []).forEach(function (a) {
        var app = a.discount_application || {};
        if (a.amount > 0 && app.value_type === 'percentage' && parseFloat(app.value) >= 100) {
          free += Math.ceil(a.amount / line.original_price);
        }
      });
    });
    return { n: n, free: free };
  }

  // The pick tray re-fetches mss-cart-state itself after a cart update when it is showing or holds picks.
  function trayWillFetch() {
    var tray = document.querySelector('mss-pick-tray');
    if (!tray || !window.MssPick) return false;
    if (!tray.hasAttribute('hidden')) return true;
    try {
      return (window.MssPick.get() || []).length > 0;
    } catch (e) {
      return false;
    }
  }

  var offerTimer = null;
  var waitTimer = null;
  var offerSeq = 0;
  var pendingSince = 0;
  var stateAt = 0;

  function refreshOffer(event) {
    if (!offerBoxes().length) return;
    // A cart response that already carries the state (e.g. the tray's ADD ALL) needs no request at all.
    var data = event && event.cartData;
    var inline = data && data.sections && parseStateHtml(data.sections['mss-cart-state']);
    if (validState(inline)) {
      onState(inline);
      return;
    }
    if (!pendingSince) pendingSince = Date.now();
    clearTimeout(offerTimer);
    offerTimer = setTimeout(function () {
      clearTimeout(waitTimer);
      if (trayWillFetch()) {
        // Reuse the tray's request; fetch ourselves only if its state doesn't arrive.
        waitTimer = setTimeout(fetchOffer, 1500);
      } else {
        fetchOffer();
      }
    }, 150);
  }

  function fetchOffer() {
    var since = pendingSince;
    if (!since || stateAt >= since) return;
    var seq = ++offerSeq;
    fetchState().then(function (state) {
      if (seq !== offerSeq) return;
      if (validState(state)) {
        onState(state);
        return;
      }
      fetchCart().then(function (cart) {
        if (seq !== offerSeq || !cart) return;
        var c = fromCart(cart);
        pendingSince = 0;
        renderOffer(c.n, c.free);
      });
    });
  }

  function onState(state) {
    stateAt = Date.now();
    pendingSince = 0;
    offerSeq++;
    clearTimeout(waitTimer);
    renderState(state);
  }

  function initOffer() {
    // First paint is rendered from the cart in Liquid; the tray's inline state (if any) is broadcast on load.
    document.addEventListener('mss:cart-state', function (e) {
      if (validState(e.detail)) onState(e.detail);
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshOffer);
    }
    document.addEventListener('cart:refresh', function () {
      refreshOffer();
    });
    document.addEventListener('mss:cart-updated', function () {
      refreshOffer();
    });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) refreshOffer();
    });
    // Halloween Buy 3 Get 2 ended on an open page: the ladder hides itself (data-mss-hw), the Buy 2 Get 1 row comes
    // back; re-render its line from the last counts, then ask the server (Shopify's own allocations after the end).
    document.addEventListener('mss:offer-change', function () {
      var first = offerBoxes()[0];
      if (first && first.hasAttribute('data-mss-offer-count')) {
        renderOffer(Number(first.getAttribute('data-mss-offer-count')) || 0, Number(first.getAttribute('data-mss-offer-free')) || 0);
      }
      pendingSince = Date.now();
      fetchOffer();
    });
    var tray = window.MssPick && window.MssPick.cartState && window.MssPick.cartState();
    if (validState(tray)) onState(tray);
  }

  /* ---------- 2. Smart dropdowns ---------- */
  function onSmartChange(e) {
    var select = e.target;
    if (!select || select.tagName !== 'SELECT') return;
    var picker = select.closest('variant-selects[data-mss-smart]');
    if (!picker) return;
    var selects = Array.prototype.slice.call(picker.querySelectorAll('select'));
    var index = selects.indexOf(select);
    if (index < 0 || index === selects.length - 1) return;
    var combos = readJson(picker.querySelector('[data-mss-combos]')) || [];
    var current = selects.map(function (s) {
      return s.value;
    });
    var exact = combos.some(function (c) {
      return current.every(function (v, i) {
        return c[i] === v;
      });
    });
    if (exact) return;
    var match = null;
    for (var i = 0; i < combos.length && !match; i++) {
      var ok = true;
      for (var j = 0; j <= index; j++) {
        if (combos[i][j] !== current[j]) ok = false;
      }
      if (ok) match = combos[i];
    }
    if (!match) return;
    for (var k = index + 1; k < selects.length; k++) {
      var s = selects[k];
      var target = null;
      Array.prototype.forEach.call(s.options, function (o) {
        o.removeAttribute('selected');
        if (o.value === match[k]) target = o;
      });
      if (!target) continue;
      target.removeAttribute('hidden');
      target.removeAttribute('disabled');
      target.setAttribute('selected', 'selected');
      s.value = match[k];
    }
  }

  document.addEventListener('change', onSmartChange, true);

  /* ---------- 3. Mobile sticky Add to cart ---------- */
  if (!customElements.get('mss-sticky-atc')) {
    customElements.define(
      'mss-sticky-atc',
      class MssStickyAtc extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          this.form = document.getElementById(this.dataset.form);
          this.productForm = this.form && this.form.closest('product-form');
          this.mainBtn = this.productForm && this.productForm.querySelector('[type="submit"][name="add"]');
          if (!this.form || !this.mainBtn) return;
          this.ready = true;
          this.btn = this.querySelector('[data-satc-add]');
          this.btnLabel = this.querySelector('[data-satc-label]');
          this.mq = window.matchMedia('(max-width: 749px)');
          this.mainInView = true;
          this.mainAbove = false; // true only once the buy button has been scrolled PAST (above the viewport)
          this.shown = false;
          this.update = this.update.bind(this);
          this.sync = this.sync.bind(this);

          this.btn.addEventListener('click', this.onClick.bind(this));

          // Shown only after the shopper has scrolled past the main buy button (never on first load, when the
          // button is still below the fold and the price tag is what they should see).
          var target = this.mainBtn.closest('.product-form__buttons') || this.mainBtn;
          // Recompute from the button's real position on scroll too: an IntersectionObserver only fires when the
          // button crosses the viewport edge, so an instant jump (e.g. tapping the iOS status bar) would leave a
          // stale state behind.
          this.target = target;
          this.onScroll = function () {
            if (this.raf) return;
            this.raf = window.requestAnimationFrame(function () {
              this.raf = 0;
              var r = this.target.getBoundingClientRect();
              this.mainInView = r.bottom > 0 && r.top < window.innerHeight;
              this.mainAbove = r.bottom <= 0;
              this.update();
            }.bind(this));
          }.bind(this);
          window.addEventListener('scroll', this.onScroll, { passive: true });
          if ('IntersectionObserver' in window) {
            this.io = new IntersectionObserver(
              function (entries) {
                entries.forEach(function (entry) {
                  this.mainInView = entry.isIntersecting;
                  this.mainAbove = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
                }, this);
                this.update();
              }.bind(this),
              { threshold: 0 }
            );
            this.io.observe(target);
          }

          // Mirror the main button (sold out / unavailable / loading) and keep out of the pick tray's way.
          this.mo = new MutationObserver(this.sync);
          this.mo.observe(this.mainBtn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'], childList: true, subtree: true, characterData: true });
          this.trayMo = new MutationObserver(this.update);
          this.trayMo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
          var tray = document.querySelector('mss-pick-tray');
          if (tray) this.trayMo.observe(tray, { attributes: true, attributeFilter: ['hidden'] });
          if (this.mq.addEventListener) this.mq.addEventListener('change', this.update);
          else if (this.mq.addListener) this.mq.addListener(this.update);

          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubVariant = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariant.bind(this));
          }
          this.sync();
          this.update();
        }

        disconnectedCallback() {
          if (this.io) this.io.disconnect();
          if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
          if (this.mo) this.mo.disconnect();
          if (this.trayMo) this.trayMo.disconnect();
          if (this.mq && this.mq.removeEventListener) this.mq.removeEventListener('change', this.update);
          if (typeof this.unsubVariant === 'function') this.unsubVariant();
          document.documentElement.classList.remove('mss-satc-on');
          this.ready = false;
        }

        trayShowing() {
          var tray = document.querySelector('mss-pick-tray');
          return Boolean(tray && !tray.hasAttribute('hidden'));
        }

        update() {
          var show = this.mq.matches && !this.mainInView && this.mainAbove && !this.trayShowing();
          if (show === this.shown) return;
          this.shown = show;
          this.classList.toggle('is-shown', show);
          this.toggleAttribute('inert', !show);
          this.setAttribute('aria-hidden', show ? 'false' : 'true');
          document.documentElement.classList.toggle('mss-satc-on', show);
        }

        canBuy() {
          var input = this.form.querySelector('input[name="id"]');
          return Boolean(
            input &&
              input.value &&
              !input.disabled &&
              !this.mainBtn.hasAttribute('disabled')
          );
        }

        sync() {
          var busy = this.mainBtn.classList.contains('loading');
          var can = this.canBuy();
          this.btn.classList.toggle('is-loading', busy);
          this.btn.setAttribute('aria-busy', busy ? 'true' : 'false');
          this.classList.toggle('is-unavailable', !can);
          // Same words as the main button ("Add to cart" / "Sold out" / "Unavailable").
          var span = this.mainBtn.querySelector('span:not(.hidden):not(.loading__spinner)');
          var text = span ? span.textContent.trim() : '';
          if (text && this.btnLabel && this.btnLabel.textContent !== text) this.btnLabel.textContent = text;
        }

        onVariant(event) {
          var data = event && event.data;
          if (!data || data.sectionId !== this.dataset.section || !data.html) return;
          var fresh = data.html.getElementById(this.id);
          if (!fresh) return;
          ['[data-satc-media]', '[data-satc-price]'].forEach(function (sel) {
            var from = fresh.querySelector(sel);
            var to = this.querySelector(sel);
            if (from && to && to.innerHTML !== from.innerHTML) to.innerHTML = from.innerHTML;
          }, this);
          this.sync();
        }

        onClick(e) {
          e.preventDefault();
          if (this.btn.getAttribute('aria-busy') === 'true') return;
          if (!this.canBuy()) {
            this.scrollToPicker();
            return;
          }
          // Submit the real product form: Dawn's product-form adds the selected variant + quantity, renders and opens
          // the cart drawer, publishes cartUpdate and shows any error.
          if (typeof this.form.requestSubmit === 'function') this.form.requestSubmit(this.mainBtn);
          else this.mainBtn.click();
          var watchError = function () {
            var err = this.productForm.querySelector('.product-form__error-message-wrapper');
            if (err && !err.hasAttribute('hidden')) this.scrollTo(err);
          }.bind(this);
          setTimeout(function wait() {
            if (this.mainBtn.classList.contains('loading')) setTimeout(wait.bind(this), 200);
            else watchError();
          }.bind(this), 300);
        }

        scrollTo(el) {
          var top = el.getBoundingClientRect().top + window.pageYOffset - 110;
          window.scrollTo({ top: Math.max(top, 0), behavior: reduceMotion() ? 'auto' : 'smooth' });
        }

        scrollToPicker() {
          var scope = this.form.closest('product-info') || document;
          var picker = scope.querySelector('variant-selects') || this.productForm;
          this.scrollTo(picker);
          var field = picker.querySelector('select, input:not([type="hidden"]):not(:disabled)');
          if (field) {
            setTimeout(function () {
              field.focus({ preventScroll: true });
            }, reduceMotion() ? 0 : 450);
          }
        }
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOffer);
  } else {
    initOffer();
  }
})();
